import { subscribe } from '../state.js';
import { translate } from '../lib/i18n.js';

export function renderAboutView(container: HTMLElement): () => void {
  function render(): void {
    container.innerHTML = '';

    const view = document.createElement('div');
    view.className = 'view about-view';

    view.innerHTML = `
      <div class="view__header">
        <h1 class="view__title">${translate('about.title', 'About')}</h1>
      </div>
      <p class="about-view__tagline">
        ${translate('about.tagline', 'Steven Pinker famously said "syntax is an app that uses a tree of phrases to translate a web of thoughts into a string of words". Crosslink makes my web visible.')}
      </p>

      <div class="about-section">
        <h2 class="about-section__title">${translate('about.what_title', 'What is Crosslink?')}</h2>
        <div class="about-section__body">
          <p>${translate('about.what_body_1', `You can think of crossxlink as my personal doodle book. We're all brief visitors making sense of things. It\'s styled as "crossxlink" because it\'s cool and I can get a .com domain :P`)}</p>
          <p>${translate('about.what_body_2', `I believe that creating nodes and edges, flowcharts, and system simulations will help me clarify the things that I thought I already understood.`)}</p>
        </div>
      </div>

      <div class="about-section">
        <h2 class="about-section__title">${translate('about.how_title', 'How it works')}</h2>
        <div class="about-section__body">
          <p>${translate('about.how_body_1', 'Click around to explore and experiment.')}</p>
          <p>${translate('about.how_body_2', 'This is very much a work in progress and there\'s no "spec" so to speak.')}</p>
        </div>
      </div>

      <div class="about-section">
        <h2 class="about-section__title">${translate('about.contact_title', 'Who created Crosslink?')}</h2>
        <div class="about-section__body">
          <p>${translate('about.contact_body_1', 'My name is Erica Xu aka Silver in the Obsidian community. In 2020 I co-founded Obsidian.')}</p>
          <p>${translate('about.contact_body_2', 'If you have something to tell me about crossxlinks you can reach out at i-a-m at my full name dot com, thanks. Keep learning!')}</p>
        </div>
      </div>
    `;

    container.appendChild(view);
  }

  render();

  const langUnsub = subscribe('lang', render);

  return () => langUnsub();
}
